import type { PaginatedResponse } from '@/shared/api/types/api-response'
import type {
  SurveyAnswersListParams,
  SurveyQuestionsListParams,
  SurveyResponsesListParams,
  SurveyVersionsListParams,
} from '@/shared/api/types/survey-types'

export interface SurveyListPageDTO<T> {
  data: T[]
  total: number
  pageSize: number
  current: number
  keyword?: string | null
  currentSize?: number
}

export function mapSurveyListPageToPaginated<T>(
  page: SurveyListPageDTO<T>,
  params:
    | SurveyVersionsListParams
    | SurveyQuestionsListParams
    | SurveyAnswersListParams
    | SurveyResponsesListParams,
): PaginatedResponse<T> {
  return {
    data: page.data ?? [],
    total: page.total,
    current: params.current ?? page.current,
    keyword: page.keyword ?? null,
    pageSize: params.pageSize ?? page.pageSize,
  }
}
